import React, { type ReactElement, type ReactNode, useState, useEffect } from "react"
import { useSelector } from "react-redux";
import { RootState } from "src/app/store";
import { OrderType } from "../../types/OrderType";

export interface OrderListProps {
        orderClick: (event: React.MouseEvent<HTMLDivElement>) => void,
        orderList: OrderType[],
        children?: ReactNode
}

export default function OrderList(props: OrderListProps): ReactElement {
        const { passwordProfiles } = useSelector((state: RootState) => state.passwordProfiles);
        const [localOrderLists, setLocalOrderLists] = useState<OrderType[]>([]);
        const { authUser } = useSelector((state: RootState) => state.auth);
        const { orders } = useSelector((state: RootState) => state.orders);
        const { dealers } = useSelector((state: RootState) => state.dealers);
        const { endUsers } = useSelector((state: RootState) => state.endUsers);
        const { endUserInstances } = useSelector((state: RootState) => state.endUserInstances);
        const { endUserInstanceLocations } = useSelector((state: RootState) => state.endUserInstanceLocations);


        const orderClick = (event: React.MouseEvent<HTMLDivElement>) => {
                props.orderClick(event);
        }

        const alterDealer = () => {

        }

        useEffect(() => {
                setLocalOrderLists(props.orderList);
        }, []);

        return <>
                <div className="flex flex-col overflow-auto gap-2">
                        <h3 className="shadow-[0px_0px_5px_rgba(0,0,0,0.25)] p-4">
                                <div className="grid grid-cols-1">
                                        <div className="grid grid-cols-8 font-semibold text-blue-700">
                                                <p className="text-center">Order Id</p>
                                                <p className="text-center">Sales Order Number</p>
                                                <p className="text-center">Dealer</p>
                                                <p className="text-center">EndUser</p>
                                                <p className="text-center">Cloud</p>
                                                <p className="text-center">Location</p>
                                                <p className="text-center">Number Of Doors</p>
                                                <p className="text-center">Order Date</p>
                                        </div>
                                </div>
                        </h3>
                        {
                                localOrderLists.map((item) =>
                                        <div className="grid grid-cols-8 cursor-pointer p-2 shadow-[0px_0px_5px_rgba(0,0,0,0.25)] hover:shadow-[0px_0px_5px_rgba(0,0,0,0.5)]" id={item.Id.toString()} key={item.Id} onClick={orderClick}>
                                                <p className="text-center">{item?.OrderId}</p>
                                                <p className="text-center">{item.SalesOrderNumber}</p>
                                                <p className="text-center">{item.DealerName}</p>
                                                <p className="text-center">{item.EndUserName}</p>
                                                <p className="text-center">{item.EndUserInstanceName}</p>
                                                <p className="text-center">{item.EndUserInstanceLocationName}</p>
                                                <p className="text-center">{item.NumberOfDoors}</p>
                                                <p className="text-center">{item.OrderDate}</p>
                                        </div>
                                )
                        }
                </div>
        </>
}
